import api from "@/core/services/api.service";

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UniService = {
    async Events() {
        try {
            api.setHeader();
            const response = await api.get("acr/institution", "events");
            return response;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response)
        }
    },
    async Sports(id) {
        try {
            api.setHeader();
            const response = await api.get("acr/institution/sports", id);
            return response;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response)
        }
    },
    async Ubigeo(){
        try {
            api.setHeader();
            const response = await api.get("api", "ubigeo");
            return response;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response)
        }
    }
}

export default UniService
export { UniService, AuthenticationError }